"use strict";

window.DESKTOP_BREAKPOINT = 1200;
window.TABLET_BREAKPOINT = 800;
window.PHONE_BREAKPOINT = 400;

const Global = require("./global.js");
const Videos = require("./videos.js");
const Galeries = require("./galeries.js");

let init = function() {
  $(document).ready(function() {
    new Global();
  });

  $(window).on("load", function() {
    $(".fullscreen-gallery-section .gallery").each(function() {
      new Galeries.Gallery(this);
    });
    $(".text-gallery").each(function() {
      new Galeries.TextGallery(this);
    });
    $(".inline-gallery").each(function() {
      new Galeries.InlineGallery(this);
    });
    $(".vimeo-video").each(function() {
      new Videos.Vimeo(this);
    });
    $(".youtube-video").each(function() {
      new Videos.Youtube(this);
    });
    $(".awards-section .slider").each(function() {
      new Galeries.AwardsSlider(this);
    });
  });
};

module.exports = init();
